import { BORDER_COLORS } from "../../../../../components/Charts/constants";
import { LiabilitiesObject } from "../../../types";
import { BorrowingCostDatum, DebtMixDatum } from "./types";

// Colour follows the original list position to match the dot in LiabilitiesHoldings; only display order is sorted.
export const buildDebtMix = (
  liabilities: LiabilitiesObject[],
): DebtMixDatum[] => {
  const total = liabilities.reduce(
    (sum, liability) => sum + liability.currentAmount,
    0,
  );

  if (total <= 0) {
    return [];
  }

  return liabilities
    .map((liability, index) => ({
      liability,
      color: BORDER_COLORS[index % BORDER_COLORS.length],
    }))
    .toSorted((a, b) => b.liability.currentAmount - a.liability.currentAmount)
    .map(({ liability, color }) => ({
      id: liability.id,
      name: liability.name,
      percent: (liability.currentAmount / total) * 100,
      color,
    }));
};

// Widths are normalised to each liability's own total paid so the two segments fill the track.
export const buildBorrowingCost = (
  liabilities: LiabilitiesObject[],
): BorrowingCostDatum[] => {
  return liabilities
    .toSorted((a, b) => b.interestAmount - a.interestAmount)
    .map((liability) => {
      const total = liability.principalAmount + liability.interestAmount;
      const hasPaid = total > 0;
      return {
        id: liability.id,
        name: liability.name,
        interest: liability.interestAmount,
        principalWidth: hasPaid ? (liability.principalAmount / total) * 100 : 0,
        interestWidth: hasPaid ? (liability.interestAmount / total) * 100 : 0,
      };
    });
};
